type LiteralUnion<T extends U, U = string> = T | (U & Record<never, never>);

export type EventTypes = LiteralUnion<
  | "add_to_cart"
  | "add_to_wishlist"
  | "remove_from_cart"
  | "begin_checkout"
  | "purchase"
  | "view_cart"
  | "view_item"
  | "view_item_list"
  | "search"
  | "sign_up"
  | "page_view"
  | "select_item"
  | "select_product_size"
  | "add_shipping_info"
  | "add_payment_info"
>;

export type EventDispatcher = "centra";

export interface DataEvent {
  detail: {
    type: "frd-event-type";
    event: EventTypes;
    data: unknown;
    additionalData: {
      dispatcher: EventDispatcher;
      [key: string]: any;
    };
  };
}

export type EventCallback = (detail: DataEvent["detail"]) => void;

export class EventStore {
  subscribe = (callback: EventCallback) => {
    const controller = new AbortController();

    document.addEventListener(
      "frd-event-type",
      (event) => {
        if (!(event instanceof CustomEvent)) return;

        if (event.detail.type !== "frd-event-type") return;

        const detail = event.detail as DataEvent["detail"];

        callback(detail);
      },
      { signal: controller.signal }
    );

    return () => {
      controller.abort();
    };
  };

  dispatch = (
    event: EventTypes,
    data: any,
    additionalData?: DataEvent["detail"]["additionalData"]
  ) => {
    const customEvent = new CustomEvent("frd-event-type", <DataEvent>{
      detail: {
        type: "frd-event-type",
        event,
        data,
        additionalData,
      },
    });

    document.dispatchEvent(customEvent);
  };
}

export const events = new EventStore();
